const { default: Swal } = require("sweetalert2");

$(function(){
  
  $(".action-view-parts-to-return").on("click", function (e) {
    $.get(`${window.baseUrl}invoice/parttoreturnlist`, function(msg) {
      let popup = bootbox.dialog({
        title: "Pièces à retourner",
        message: msg,
        className: "modal-part_to_return_list",
        size: "large",
        buttons: {
          add:{
            label: "Ajouter une pièce",
            className: "btn green",
            callback: function() {
              showPartReturnForm();             
              return false;
            }
          },
          remove:{
            label: "Remettre dans l'inventaire",
            className: "btn red",
            callback: function() {
              let checkboxes = $(".checkbox-select-item:checked");
              let itemIds = [];
              checkboxes.each(function(){
                itemIds.push($(this).val());
              });
              deleteReturnInvoiceFromPartList(itemIds, (success) => {
               if(success) {
                  for (const itemId of itemIds) {
                    $("#form_part_to_return").find("tr[item-id=\""+itemId+"\"]").remove();
                  }
                }
             });
              return false;
            }
          },
          save: {
            label: "Créer facture de retour",
            className: "btn blue",
            callback: function() {
              let checkboxes = $(".checkbox-select-item:checked");
              let itemIds = [];
              checkboxes.each(function(){
                itemIds.push($(this).val());
              });
              window.createReturnInvoiceFromPartList(itemIds, (success) => {
                if(success) {
                  for (const itemId of itemIds) {
                    $("#form_part_to_return").find("tr[item-id=\""+itemId+"\"]").remove();
                  }
                }
              });
              return false;
            }
          },
          close: {
            label: "Fermer",
            className: "btn",
            callback: function(){}
          }
        }
      })
    })
  });

  $("body").on("click", ".checkbox-select-all", function(e) {
    let checkboxItems = $(this).closest("table").find(".checkbox-select-item");
    let value = $(this).prop("checked");
    checkboxItems.each(function() {
      $(this).prop("checked", value);
    })
  })

})

deleteReturnInvoiceFromPartList = function(item_ids, callback)
{
  if(item_ids.length == 0){
    Swal.fire("Erreur", "Veuillez sélectionner au moins une pièce.", "error");
    return;
  }
  //console.log(item_ids)
  let popup = bootbox.dialog({
    title: "Remettre dans l'inventaire",
    message: "Voulez-vous remettre la facture dans l'inventaire?",
    size:"small",
    buttons:{
      save:{
        label: "Confirmer",
        className: "btn purple",
        callback: function() {
          //var filters = $("#form_filter_invoice_detail").serialize();
          //console.log(filters)
          $.post(`${window.baseUrl}invoice/removedetail`, {ids: item_ids}, function(json) {
            processPopupServerResponse(popup, true);
            toastr.success("Pièce remis dans l'inventaire avec succès!", "Succès")
            callback(true)
          })
          return false;
        }
      },
      cancel:{
        label: "Annuler",
          className: "btn",
          callback: function() {
            
          }
      }
    }
  })
}


window.createReturnInvoiceFromPartList = function(item_ids, callback) {

  if(item_ids.length == 0){
    Swal.fire("Erreur", "Veuillez sélectionner au moins une pièce.", "error");
    return;
  }

  $.post(`${window.baseUrl}supplier_invoice/createfrominvoiceitems`, {ids: item_ids}, function(formHtml) {

    let popup = bootbox.dialog({
      title: "Créer une facture de retour",
      message: formHtml,
      className: "modal-supplier_invoice",
      size: "large",
      buttons: {
        save: {
          label: "Sauvegarder",
          className: "btn purple",
          callback: function() {
            let form = $("#form_supplier_invoice");
            if(form.valid()) {
              $.post(`${window.baseUrl}supplier_invoice/createfrominvoiceitems/save`, {form: form.serialize()}, function(json) {
                processPopupServerResponse(popup, true);

                toastr.success("Facture de retour créée avec succès!", "Succès", {
                  onclick: function() {
                    window.location.href = `${window.baseUrl}supplier_invoice/view/${json.id}`
                  }
                })

                callback(true)
              }, "json").fail(function() {
                processPopupServerResponse(popup, false);
                callback(false)
              });
            }
            return false;
          }
        },
        cancel: {
          label: "Annuler",
          className: "btn",
          callback: function() {
            
          }
        }
      }
    })

  });
}


//Début de action-add-part-return
function showPartReturnForm() {
  var message_text = "<h1>"+L("PROCESSING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
  App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });

  var request = $.ajax({
    url: `${window.baseUrl}invoice/addPartToReturn`,
    type: "POST",
    data: {},
    dataType: "html"
  });

  request.done(function (msg) {
    App.unblockUI();
    var popup = bootbox.dialog({ 
      message: msg,
      title: "Ajout de pièce à retourner",
      className: "modal-part-return",
      size: "medium",
      buttons: {
        save: {
          label: L("SAVE"),
          className: "purple",
          callback: function() {
            if($("#form_return_part").valid()){
              addPartReturn($("#form_return_part").serialize(), function(success){
                processPopupServerResponse(popup, success);
              });
            }
            return false;
          }
        },
        cancel: {
          label: L("CANCEL"),
          className: "btn",
          callback: function() {

          }
        }
      }
    });
  });
  request.fail(function(jqXHR, textStatus, thrownErr) {
    App.unblockUI();
    processXHRError(jqXHR, textStatus, thrownErr);
    console.log( "Request add part return failed: " + textStatus );
  });
}
//FIN de action-add-part-return
  
function addPartReturn(data, callback){
	if(callback == undefined) callback = function(success){ };
	var message_text = "<h1>"+L("SAVING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
	App.blockUI({ message: message_text ,boxed: true, zIndex: 20000 });
	var request = $.ajax({
		url: `${window.baseUrl}invoice/createPartToReturn`,
		type: "POST",
		data: { form : data },
		dataType: "html"
	});
	request.done(function(msg) {
		App.unblockUI();
    callback(true);
    $.get(`${window.baseUrl}invoice/parttoreturnlist`, function(body) {
      $(".modal-part_to_return_list .modal-body").html(body);
      $('tr[item-id='+msg+']').addClass("bg-blue-sharp");
      $('input[value='+msg+']').trigger('focus')
    });
  });
	request.fail(function(jqXHR, textStatus, thrownErr) {
		App.unblockUI();
		processXHRError(jqXHR, textStatus, thrownErr);
		callback(false);
		console.log( "Request addPart failed: " + textStatus );
	});
}
